export default {
  connexion_token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJpZCI6ImRkM2UzM2NmYzM2ZjU4YmFhMWVmOTA0OWQwMTFlNzczNmEyNWI4MjgiLCJqdGkiOiJkZDNlMzNjZmMzNmY1OGJhYTFlZjkwNDlkMDExZTc3MzZhMjViODI4IiwiaXNzIjoiaHR0cHM6XC9cL3dzLWludGVnLmFpcmJ1cy1zdGFmZmNvdW5jaWwuY29tIiwiYXVkIjoiYW1wbGl0dWRlcyIsInN1YiI6Ijk5OTM4NTI3MyIsImV4cCI6MTUxMzc5MDM1NCwiaWF0IjoxNTEzNzg2NzU0LCJ0b2tlbl90eXBlIjoiYmVhcmVyIiwic2NvcGUiOiJvcGVuaWQgcHJvZmlsZSBlbWFpbCBhZGRyZXNzIHBob25lIG9kIGZhbWlseSJ9.d6g6W6Ewgdk4-ELoCafa3rdwkwA8ihNA2NIBMDM4D-HNGXHxxa5OthjBpTejO6sot116SUw8-yY8dIvkMF6njfGHOPOomluZ5egsVKeLMJtMW9hClsqY6FuxVH2m0KfZ298HfV1eLua96aPFm_MudtGXPR3w8ZH5YlgyfX0PEF-YVX6c9cebtIagowKcPHVvO8s3msoLFDSmLE-pT2CdYisC_GECTKUlJDLvkz8RYrN87ehDBA2jvKknAH7he043PfuO2bUwf_wb_VifEP6Ob6Pk8w_hMSzW0CIpmSwtnGxVMjAxV3Ayy9VXrmEcI_5mLb4hSXrdcx6wio-5nC18Ww',
  civility: 'mr',
  first_name: 'Stephane',
  last_name: 'JIDOUARD',
  usage_first_name: '',
  usage_last_name: '',
  registration_number: '287777',
  birthday: '1980-08-28',
  street_1: '37 t Rue de Metz',
  street_2: '',
  zip_code: '31000',
  city: 'Toulouse',
  country_name: 'France',
  country_code: 'FR',
  phone_business: '',
  phone_personnal: '',
  phone_mobile: '+33612345678',
  email: 'stephane@amplitudes.com',
  family: [{
    registration_number: '287777',
    first_name: 'Stephane',
    last_name: 'Jidouard',
    usage_first_name: '',
    usage_last_name: '',
    birthday: '1980-08-28',
    civility: 'mr',
    possibleFirstName: null,
    possibleLastName: null
  }, {
    registration_number: '287607',
    first_name: 'Claude',
    last_name: 'Iks',
    usage_first_name: '',
    usage_last_name: '',
    birthday: '1980-08-28',
    civility: 'mr',
    possibleFirstName: null,
    possibleLastName: null
  }, {
    registration_number: '287699',
    first_name: 'AZERTYUIOPQSDFGHJKLMWXCVBN',
    last_name: 'Abcdefghijklmnopqrstuvwxyz',
    usage_first_name: 'Michel',
    usage_last_name: 'Abcdefghijklmnopqrstuvwxyz',
    birthday: '1980-08-28',
    civility: 'mr',
    possibleFirstName: null,
    possibleLastName: null
  }, {
    registration_number: '287699',
    first_name: 'AAAZERTYUIOPQSDFGHJKLMWXCVBN',
    last_name: 'AAAbcdefghijklmnopqrstuvwxyz',
    usage_first_name: '',
    usage_last_name: '',
    birthday: '1980-08-28',
    civility: 'mr',
    possibleFirstName: null,
    possibleLastName: null
  }, {
    registration_number: '124980',
    first_name: 'Claude',
    last_name: 'Iks',
    usage_first_name: 'Pintade',
    usage_last_name: '',
    birthday: '1983-09-08',
    civility: 'mrs',
    possibleFirstName: null,
    possibleLastName: null
  }, {
    registration_number: '867AD01',
    last_name: 'Hu',
    usage_first_name: '',
    first_name: 'Margot--Hélène',
    usage_last_name: '',
    civility: 'mrs',
    birthday: '2004-07-08',
    possibleFirstName: null,
    possibleLastName: null
  }, {
    registration_number: '867AD02',
    last_name: 'Hu',
    usage_first_name: '',
    first_name: 'Martin - Pierre',
    usage_last_name: '',
    civility: 'mr',
    birthday: '2002-05-23',
    possibleFirstName: null,
    possibleLastName: null
  }, {
    registration_number: '287607AD01',
    last_name: 'Iks',
    usage_first_name: '',
    first_name: 'Léopold',
    usage_last_name: '',
    civility: 'mr',
    birthday: '2019-06-12',
    possibleFirstName: null,
    possibleLastName: null
  }, {
    registration_number: '287607AD02',
    last_name: 'Iks',
    usage_first_name: 'Stanislas',
    first_name: 'Stanislas Jean-Philippe Alfred',
    usage_last_name: '',
    civility: 'mr',
    birthday: '2017-06-11',
    possibleFirstName: null,
    possibleLastName: null
  }, {
    registration_number: '124980AD01',
    last_name: 'Iks',
    usage_first_name: '',
    first_name: 'John',
    usage_last_name: '',
    civility: 'mr',
    birthday: '2010-04-07',
    possibleFirstName: null,
    possibleLastName: null
  }, {
    registration_number: '161204AD01',
    last_name: 'LaGarde',
    usage_first_name: '',
    first_name: 'Arsène',
    usage_last_name: '',
    civility: 'mr',
    birthday: '2008-09-09',
    possibleFirstName: null,
    possibleLastName: null
  }, {
    registration_number: '161204AD02',
    last_name: 'LAgarde',
    usage_first_name: '',
    first_name: 'Marius',
    usage_last_name: '',
    civility: 'mr',
    birthday: '2005-05-17',
    possibleFirstName: null,
    possibleLastName: null
  }, {
    registration_number: '161204AD03',
    last_name: 'LAgarde',
    usage_first_name: '',
    first_name: 'Steph',
    usage_last_name: '',
    civility: 'mr',
    birthday: '2022-05-16',
    possibleFirstName: null,
    possibleLastName: null
  }, {
    registration_number: '161204AD04',
    last_name: 'LAgarde',
    usage_first_name: '',
    first_name: 'bebefin',
    usage_last_name: '',
    civility: 'mr',
    birthday: '2019-05-16',
    possibleFirstName: null,
    possibleLastName: null
  }
  ]
}
